import {Mission, Cart, Login, Offering, Finish, ClientInfo, Dashboard, Commission} from '../screens';

export default [
    {
        path: '/home',
        component: ClientInfo
    },
    {
        path: '/mission',
        component: Mission
    },
    {
        path: '/offering/:id',
        component: Offering
    },
    {
        path: '/cart',
        component: Cart
    },
    {
        path: '/finish',
        component: Finish
    },
    {
        path: '/login',
        component: Login
    },
    {
        path: '/dashboard',
        component: Dashboard
    },
    {
        path: '/commission',
        component: Commission
    }
];
